module.exports = __webpack_public_path__ + "static/media/controller.6e01be87.png";